import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectCurrentSurvey,
  selectIsLoading,
} from "redux-toolkit/surveys/selectors";
import {
  getSurveyByIdAsync,
  createSurveyAsync,
  updateSurveyAsync,
  deleteSurveyAsync,
} from "redux-toolkit/surveys/actions";

const useSurvey = ({ id }) => {
  const dispatch = useDispatch();
  const current = useSelector(selectCurrentSurvey);
  const isLoading = useSelector(selectIsLoading);

  useEffect(() => {
    id && dispatch(getSurveyByIdAsync(id));
  }, [dispatch, id]);

  const createSurvey = useCallback(
    (newSurvey) => {
      dispatch(createSurveyAsync(newSurvey));
    },
    [dispatch],
  );

  const updateSurvey = useCallback(
    (id, data) => {
      dispatch(updateSurveyAsync({ id, data }));
    },
    [dispatch],
  );

  const deleteSurvey = useCallback(() => {
    dispatch(deleteSurveyAsync(id));
  }, [id, dispatch]);

  return {
    current,
    isLoading,
    createSurvey,
    updateSurvey,
    deleteSurvey,
  };
};

export default useSurvey;
